<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Borusan Raporu</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom left>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="getReportExcel()">
                  <v-list-tile-title
                    >Excel {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-3>
          <v-form ref="formborusan" v-model="valid" lazy-validation>
            <v-card class="pa-2">
              <v-layout row wrap>
                <v-flex xs12 sm12 md2>
                  <tarihcomp
                    :etiket="$t('Starting-Date')"
                    :detaygizle="false"
                    v-bind:defaultvalue="'ok'"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-model="searchParams.BaslangicTarih"
                  ></tarihcomp>
                </v-flex>
                <v-flex xs12 sm4 md2>
                  <tarihcomp
                    :etiket="$t('Finishing-Date')"
                    :detaygizle="false"
                    v-bind:defaultvalue="'ok'"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-model="searchParams.BitisTarih"
                  ></tarihcomp>
                </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-select
                    label="Rapor Tipi"
                    :items="reportTypeItems"
                    v-model="searchParams.RaporTipi"
                    item-text="text"
                    item-value="value"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <v-text-field
                    label="Bilet No"
                    v-model="searchParams.BiletNo"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <v-autocomplete
                    hide-details=""
                    :items="itemsairlinelist"
                    clearable
                    item-text="Title"
                    item-value="HavaYoluKodu"
                    :label="$t('Airline-Code')"
                    v-model="searchParams.HavayoluKodu"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <cariaracomp 
                    v-bind:etiket="$t('Select-Current')"
                    v-model="searchParams.CariKodu"
                  ></cariaracomp>
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <v-select
                    :items="hesapgurubu"
                    hide-details=""
                    :label="$t('Account-Group')"
                    item-text="Title"
                    item-value="Kod"
                    max-height="400"
                    v-model="searchParams.HesapGrubu"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <v-radio-group v-model="searchParams.UcusTipi" row>
                    <v-radio label="Hepsi" :value="0"></v-radio>
                    <v-radio label="İç" :value="1"></v-radio>
                    <v-radio label="Dış" :value="2"></v-radio>
                  </v-radio-group>
                </v-flex>

                <v-flex xs12 sm4 md3>
                  <v-btn @click="getReport()" small fab dark color="info">
                    <v-icon>search</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-3>
          <v-data-table
            :headers="headerBorusan"
            :rows-per-page-items="[50, 100, 200]"
            :items="borusanItems"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                {{ props.item.HavayoluKodu }}
              </td>
              <td class="text-xs-left">{{ props.item.BiletNo }}</td>
              <td class="text-xs-left">{{ props.item.YolcuAdi }}</td>
              <td class="text-xs-left">
                {{ props.item.Unvan }}
              </td>
              <td class="text-xs-left">
                {{ props.item.TedarikciKodu }}
              </td>
              <td class="text-xs-left">
                {{ props.item.SatisTarihi | dateformat }}
              </td>

              <td class="text-xs-left">
                {{ props.item.TutarTL | moneyformat }}
              </td>
              <td class="text-xs-left">
                {{ props.item.DvzTutar | moneyformat }}
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihcomp from "@/components/app/customcomp/tarihim";
import auth from "@/api/auth";
import cariaracomp from "@/components/app/customcomp/cariaracomp";

export default {
  data() {
    return {
      borusanItems: [],
      headerBorusan: [
        {
          text: "Havayolu Kodu",
        },
        {
          text: "Bilet No",
        },
        {
          text: "Yolcu Adı",
        },
        {
          text: "Ünvan",
        },
        {
          text: "Tedarikçi Kodu",
        },
        {
          text: "Satış Tarihi",
        },
        {
          text: "Tutar TL",
        },
        {
          text: "Tutar Döviz",
        },
      ],
      reportTypeItems: [
        {
          text: "BORUSAN KONTROL",
          value: 1,
        },
        {
          text: "BORUSAN REISSUE KONTROL",
          value: 2,
        },
        {
          text: "BORUSAN SEYAHAT PORTAL KONTROL",
          value: 3,
        },
      ],
      hesapgurubu: [],
      itemsairlinelist: [],
      valid: true,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      searchParams: {
        RaporTipi: 1, // 1: BORUSAN KONTROL RAPORU ,2 : BORUSAN REISSUE KONTROL RAPORU, 3 : BORUSAN SEYAHAT PORTAL KONTROL RAPORU
        SirketKodu: 0,
        BaslangicTarih: null,
        BitisTarih: null,
        BiletNo: null,
        HavayoluKodu: null,
        CariKodu: null,
        HesapGrubu: null,
        UcusTipi: 0, //  0 : Hepsi , 1 : İç Hat , 2 : Dış Hat
      },
    };
  },
  methods: {
    getReportExcel() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      if (this.$refs.formborusan.validate()) {
        this.loadingvmodel = true;

        var bastarih = new Date(this.searchParams.BaslangicTarih);
        var bittarih = new Date(this.searchParams.BitisTarih);

        if (bastarih <= bittarih) {
          this.loadingvmodel = true;

          this.searchParams.SirketKodu = credentials.SirketKodu;

          this.$http
            .post(
              auth.API_URL + "api/TicketReport/BorusanReportListExcel",
              this.searchParams,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
                responseType: "arraybuffer",
              }
            )
            .then(
              (response) => {
                this.progress = false;
                this.load1 = true;
                var blob = new Blob([response.data], {
                  type: "application/xlsx",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "BorusanRapor.xlsx";
                link.click();
                this.loadingvmodel = false;
              },
              (response) => {
                if (response.status === 0) {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                  this.loadingvmodel = false;
                } else {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                  this.loadingvmodel = false;
                }
              }
            );
        } else {
          this.text1 = this.$t("start-date-cannot-greater-than-end-date");
          this.snackbar = true;
        }
      }
    },
    getReport() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      if (this.$refs.formborusan.validate()) {
        this.loadingvmodel = true;
        this.searchParams.SirketKodu = credentials.SirketKodu;
        this.$http
          .post(
            auth.API_URL + "api/TicketReport/BorusanReportList",
            this.searchParams,
            {
              headers: {
                Authorization: "Bearer " + auth.getAuthHeader(),
              },
            }
          )
          .then(
            (response) => {
              this.borusanItems = response.body;
              this.loadingvmodel = false;
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable";
                this.snackbar = true;
                this.loadingvmodel = false;
              } else {
                this.text1 = "Service Unavailable";
                this.snackbar = true;
                this.loadingvmodel = false;
              }
            }
          );
      }
    },
    getAccountCodes() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CompanyCode: credentials.SirketKodu,
      };

      this.$http
        .post(auth.API_URL + "api/Definitions/CurrentGroupList", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.hesapgurubu = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            }
          }
        );
    },
    getAirlineCodes() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CompanyCode: credentials.SirketKodu,
      };

      this.$http
        .post(auth.API_URL + "api/TicketDefinitons/AirlineList", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.itemsairlinelist = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.progress = false;

              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.progress = false;

              this.snackbar = true;
            }
          }
        );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihcomp,
    cariaracomp,
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return m.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.getAccountCodes();
    this.getAirlineCodes();
    // this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    // if (this.sayfayetki.Status == true) {
    //   //YETKİ OK
    // } else {
    //   this.$refs.yetkidialog
    //     .open(this.sayfayetki.Message, this.sayfayetki.islem)
    //     .then((sonuc) => {
    //       if (sonuc == true) {
    //         if (this.prevRoute != null) {
    //           var url = "#" + this.prevRoute;
    //           window.open(url, "_self");
    //         } else {
    //           var mainUrl = "#/";
    //           window.open(mainUrl, "_self");
    //         }
    //       }
    //     });
    // }
  },
};
</script>

<style>
</style>

